import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: headers => {
      const token = JSON.parse(localStorage.getItem('userInfo') || '{}')?.access;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: [
    'Trip',
    'User',
    'TravelContact',
    'GoNowReminder',
    'Idea',
    'IdeaStop',
    'TripDocuments',
    'Documents',
    'Tag',
    'Notification',
    'NotificationPreferences',
    'TripReminder',
    'TripStopReminder',
    'PackingList',
    'ReferralLink',
  ],

  endpoints: builder => ({}),
});
